import React from 'react'
import { Modal } from 'react-bootstrap'
export type ModalDragHandleProps = {
  children?: any
  /** Defaults true. A caller mid an unabortable action (a batch send) passes `false` to hide it,
   * matching a footer Cancel it has already disabled for the same reason. */
  closeButton?: boolean
}
export const ModalDragHandle = ({ children, closeButton = true }: ModalDragHandleProps) => {
  return (
    <Modal.Header closeButton={closeButton} className="drag-handle" style={{ cursor: 'move' }}>
      {children}
    </Modal.Header>
  )
}
